import React, { useState, createContext } from 'react';
import { ThemeProvider } from 'styled-components';
import styled from 'styled-components';

import { HeaderHeightContext } from '../contexts/HeaderHeightContext';

import FixedSiteTop from './FixedSiteTop';
import Footer from './MainFooter';

import StandardTheme from '@standard-theme';

const MainWrapper = styled.main``;

export default ({ noLinkLogo, simpleCta, children, darkMode }) => {
	const [headerHeight, setHeaderHeight] = useState(76);

	return (
		<ThemeProvider theme={StandardTheme}>
			<HeaderHeightContext.Provider value={headerHeight}>
				<FixedSiteTop
					darkMode={darkMode}
					setHeaderHeight={setHeaderHeight}
					noMenu
					noLinkLogo={noLinkLogo}
					simpleCta={simpleCta}
				/>
				<MainWrapper headerHeight={headerHeight}>{children}</MainWrapper>
				<Footer noMenu />
			</HeaderHeightContext.Provider>
		</ThemeProvider>
	);
};
